import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Shield, X } from 'lucide-react';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem('deltaops-cookie-consent');
    // Re-apply a previous acceptance so Clarity can set its cookies on this visit
    if (consent === 'accepted' && window.clarity) {
      window.clarity('consent');
    }
    if (!consent) {
      // Small delay for better UX
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('deltaops-cookie-consent', 'accepted');
    setIsVisible(false);
    // Integrate with PostHog
    if (window.posthog) {
      window.posthog.opt_in_capturing();
    }
    // Integrate with Microsoft Clarity
    if (window.clarity) {
      window.clarity('consent');
    }
  };

  const handleDecline = () => {
    localStorage.setItem('deltaops-cookie-consent', 'declined');
    setIsVisible(false);
    // Integrate with PostHog
    if (window.posthog) {
      window.posthog.opt_out_capturing();
    }
    // Integrate with Microsoft Clarity
    if (window.clarity) {
      window.clarity('consent', false);
    }
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] p-4 md:p-6 animate-in fade-in slide-in-from-bottom-5 duration-500">
      <div className="max-w-7xl mx-auto">
        <div className="bg-slate-900 border border-cyan-500/30 backdrop-blur-md rounded-2xl shadow-2xl p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-6 ring-1 ring-white/10">
          <div className="flex items-start gap-4">
            <div className="bg-cyan-500/10 p-2 rounded-xl border border-cyan-500/20 flex-shrink-0">
              <Shield className="text-cyan-400" size={24} />
            </div>
            <div>
              <h3 className="text-white font-bold text-lg mb-1">Cookie Consent</h3>
              <p className="text-slate-300 text-sm leading-relaxed max-w-2xl">
                We use cookies to improve your experience and analyze our traffic. By clicking "Accept", you consent to our use of cookies. Read our{" "}
                <Link to="/privacy-policy" className="text-cyan-400 hover:underline font-medium">
                  Privacy Policy
                </Link>{" "}
                for more information.
              </p>
            </div>
          </div>
          
          <div className="flex flex-row items-center gap-3 w-full md:w-auto">
            <button
              onClick={handleDecline}
              className="px-6 py-2.5 rounded-xl border border-white/10 text-slate-400 hover:text-white hover:bg-white/5 transition-all text-sm font-medium flex-1 md:flex-none"
            >
              Decline
            </button>
            <button
              onClick={handleAccept}
              className="px-8 py-2.5 rounded-xl bg-cyan-500 hover:bg-cyan-400 text-slate-950 transition-all text-sm font-bold flex-1 md:flex-none shadow-lg shadow-cyan-500/20"
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
